export const defaultObj = {
  loading: false,
  data: {},
  error: '',
};
export const defaultArr = {
  loading: false,
  data: [],
  error: '',
};

export const defaultList = {
  loading: false,
  data: [],
  error: '',
  search: {
    key: 'all',
    value: '',
  },
  pagination: {
    current: 1,
    pageSize: 10,
  },
  sorter: {},
  filter: {},
  total: 0,
};
